import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IImportJob } from '@ebb-v2/ebb-integration';

@Injectable({
  providedIn: 'root'
})
export abstract class ImportJobApiService {
  abstract getImportJobList(): Observable<IImportJob[]>;
}
